import * as React from 'react';
import { getInitials, getAvatarColor } from '../../utils/chat/format';

function Avatar({
  name, size = 9, online, square = false, src,
}: { name?: string; size?: number; online?: boolean; square?: boolean; src?: string | null }) {
  const n = name || '?';
  const initials = getInitials(n);
  const color = getAvatarColor(n);
  const px = size * 4; // Tailwind unit → pixels (1 unit = 4px)
  const fontPx = size < 8 ? 10 : size < 10 ? 12 : 14;
  const rounded = square ? 'rounded-xl' : 'rounded-full';
  const cssVars = { '--avatar-size': `${px}px`, '--avatar-font-size': `${fontPx}px` } as React.CSSProperties;

  // Reset the error flag whenever the URL changes so a new upload re-attempts.
  const [imgError, setImgError] = React.useState(false);
  React.useEffect(() => { setImgError(false); }, [src]);
  const showImg = !!src && !imgError;

  return (
    <div className="gc-avatar" style={cssVars}>
      <div
        className={`gc-avatar__inner bg-gradient-to-br ${color} ${rounded} flex items-center justify-center text-white font-semibold select-none shadow-sm ${online ? 'ring-2 ring-white' : ''}`}>
        {showImg ? (
          <img
            src={src as string}
            alt={n}
            className={`gc-avatar__img ${rounded}`}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            onError={() => setImgError(true)}
            draggable={false}
          />
        ) : (
          initials
        )}
      </div>
      {online !== undefined && (
        <span className={`gc-avatar__status-dot ${online ? 'is-online gc-online-dot' : ''}`} />
      )}
    </div>
  );
}

export default Avatar;
